export default __webpack_public_path__ + "static/d06-9940ba4961bd1865502f9bab9527b928.png";